import { useServerFn } from "@/hooks/use-server-fn";
import { getPostBySlug } from "@/server-functions/get-post-by-slug";

export const usePostBySlugLoader = () => {
  return useServerFn(getPostBySlug);
};
